import React, { useEffect, useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import CloudUploadOutlinedIcon from "@material-ui/icons/CloudUploadOutlined";
import GridOnOutlinedIcon from "@material-ui/icons/GridOnOutlined";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import ReactTable from "components/Tables/ReactTable.js";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import TableHeader from "components/Tables/TableHeader";
import { useHistory } from "react-router-dom";
import useAxios from "axios/httpService";
import { apiErrorHandler } from "helpers/apiErrorHandler";
import Loading from "components/Loading/Loading";
import { NotificationManager } from "components/common/ReactNotifications";
import {
  GetAllInquirySuperAdmin,
  SurveyAnswerExport,
} from "axios/adminAPIsUrls";
import SurveyFormStatus from "components/SurveyForms/SurveyFormStatus";
import FileUploadModal from "views/SuperAdmin/MonitorActivity/FileUploadModal";
import MultiFileUploadModal from "./MultiFileUploadModal";
import SvgCalculateAverageIcon from "assets/img/svgsComponents/CalculateAverageIcon";
import SvgReviewIntakeQuestionsIcon from "assets/img/svgsComponents/ReviewIntakeQuestionsIcon";
import SvgUploadHelpDoc from "assets/img/svgsComponents/UploadHelpDoc";
import axios from "axios";
import { Config } from "config";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
  mtZero: {
    marginTop: "0px",
  },
  ptZero: {
    paddingTop: "0px !important",
  },
  longtooltip: {
    width: "fit-content !important",
    whiteSpace: "nowrap",
    zIndex: "5",
    marginTop: "-1.25rem",
    transform: "translateX(-50%)",

    "&::before": {
      left: "50%",
      transform: "translateX(-50%)",
    },
  },
  ViewResponselongtooltip: {
    width: "fit-content !important",
    whiteSpace: "nowrap",
    zIndex: "5",
    marginTop: "-1.25rem",
    transform: "translateX(-50%)",

    "&::before": {
      left: "50%",
      transform: "translateX(-50%)",
    },
  },
};

const useStyles = makeStyles(styles);
const MonitorActivity = () => {
  const history = useHistory();
  const pageSize = 8;
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  // isModal State
  const [isModalOpen, setModalOpen] = useState(false);

  // isMultiModal state
  const [isMultiModalOpen, setMultiModalOpen] = useState(false);
  const [inquiryId, setInquiryId] = useState(null);

  const token = localStorage.getItem("token");

  const [
    { data: dataInquiry, error, loading },
    ExecuteGetAllInquirySuperAdmin,
  ] = useAxios(GetAllInquirySuperAdmin(currentPage, pageSize, token), {
    manual: true,
  });

  const [
    { data: excelData, error: excelError, loading: excelLoading },
    ExecuteExportExcel,
  ] = useAxios({}, { manual: true });

  const [
    { data: wordData, error: wordError, loading: wordLoading },
    ExecuteExportWord,
  ] = useAxios({}, { manual: true });

  useEffect(() => {
    ExecuteGetAllInquirySuperAdmin(currentPage);
  }, [currentPage]);

  // Helper function to extract filename from URL
  const extractFilenameFromUrl = (url) => {
    try {
      // Decode the URL to handle encoded characters like %2F
      const decodedUrl = decodeURIComponent(url);
      // Extract the filename after the last slash
      const parts = decodedUrl.split("/");
      const filename = parts[parts.length - 1];
      return filename;
    } catch (error) {
      console.error("Error extracting filename:", error);
      return null;
    }
  };

  // Export Excel Handler
  const handleExportExcel = async (inquiryId) => {
    try {
      // First, get the URL from the API
      const response = await ExecuteExportExcel(
        SurveyAnswerExport(inquiryId, token, "excel")
      );

      // The response contains the blob storage URL in fileUrl property
      const blobUrl = response.data.fileUrl;

      // Extract filename from URL
      const filename =
        extractFilenameFromUrl(blobUrl) || `inquiry_${inquiryId}_export.xlsx`;

      // Fetch the actual file from the blob storage URL
      const fileResponse = await fetch(blobUrl);
      const blob = await fileResponse.blob();

      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export Excel failed:", error);
      // Extract error message from different possible response structures
      const errorData = error?.response?.data || error?.data;
      const errorMessage =
        errorData?.error_message ||
        errorData?.errorMessage ||
        "Failed to export Excel file";
      const errorTitle = errorData?.title || "Export Failed";

      NotificationManager.error(errorTitle, errorMessage, 5000);
    }
  };

  // Export Word Handler
  const handleExportWord = async (inquiryId) => {
    try {
      // First, get the URL from the API
      const response = await ExecuteExportWord(
        SurveyAnswerExport(inquiryId, token, "word")
      );

      // The response contains the blob storage URL in fileUrl property
      const blobUrl = response.data.fileUrl;

      // Extract filename from URL
      const filename =
        extractFilenameFromUrl(blobUrl) || `inquiry_${inquiryId}_export.docx`;

      // Fetch the actual file from the blob storage URL
      const fileResponse = await fetch(blobUrl);
      const blob = await fileResponse.blob();

      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export Word failed:", error);
      // Extract error message from different possible response structures
      const errorData = error?.response?.data || error?.data;
      const errorMessage =
        errorData?.error_message ||
        errorData?.errorMessage ||
        "Failed to export Word file";
      const errorTitle = errorData?.title || "Export Failed";

      NotificationManager.error(errorTitle, errorMessage, 5000);
    }
  };

  useEffect(() => {
    if (dataInquiry) {
      setData(
        dataInquiry.data.map((prop, key) => {
          return {
            id: prop.Id,
            inquiry: prop.Description,
            process: `${prop.Progress}%`,
            createdDate: new Date(`${prop.CreatedDate}`).toDateString(),
            status: (
              <div className="actions-center">
                <SurveyFormStatus status={prop.Status} />
              </div>
            ),
            actions: (
              <div className="actions-center">
                <Button
                  action
                  tooltipText="View Respondents"
                  justIcon
                  disabled={prop.Participants == null}
                  round
                  simple
                  size="sm"
                  color="primary"
                  onClick={() =>
                    history.push(
                      `${window.location.pathname}/view-respondents/${prop.Id}`
                    )
                  }
                >
                  <VisibilityOutlinedIcon />
                </Button>
                <Button
                  action
                  tooltipText="Upload File"
                  justIcon
                  round
                  simple
                  size="sm"
                  color="primary"
                  onClick={() => {
                    setInquiryId(prop.Id);
                    setModalOpen(true);
                  }}
                >
                  <CloudUploadOutlinedIcon />
                </Button>
                <Button
                  action
                  tooltipText="Upload Help Document"
                  justIcon
                  round
                  simple
                  size="exmd"
                  color="primary"
                  onClick={() => {
                    setInquiryId(prop.Id);
                    setMultiModalOpen(true);
                  }}
                >
                  <SvgUploadHelpDoc />
                </Button>

                <Button
                  action
                  tooltipText="View Intake Responses"
                  tooltipClassName={classes.ViewResponselongtooltip}
                  justIcon
                  round
                  simple
                  size="sm"
                  color="primary"
                  onClick={() =>
                    history.push(
                      `${window.location.pathname}/view-intake-response/${prop.Id}`
                    )
                  }
                >
                  <div
                    style={{
                      fontSize: "10px",
                    }}
                  >
                    <SvgReviewIntakeQuestionsIcon
                      style={{
                        width: "14px !important",
                        height: "16px",
                      }}
                    />
                  </div>
                </Button>
                <Button
                  action
                  tooltipClassName={classes.longtooltip}
                  align="right"
                  tooltipText="Inputs Calculation"
                  justIcon
                  round
                  simple
                  size="sm"
                  color="primary"
                  onClick={() =>
                    history.push(
                      `${window.location.pathname}/inputs/${prop.Id}`
                    )
                  }
                >
                  <div>
                    <SvgCalculateAverageIcon
                      style={{
                        width: "14px !important",
                        height: "12px",
                        marginBottom: "2px",
                      }}
                    />
                  </div>
                </Button>
                {(prop?.Status ?? "").toString().toLowerCase() ===
                  "pending" && (
                  <>
                    <Button
                      action
                      tooltipClassName={classes.longtooltip}
                      align="right"
                      tooltipText="Export Excel"
                      justIcon
                      round
                      simple
                      size="sm"
                      color="primary"
                      onClick={() => handleExportExcel(prop.Id)}
                    >
                      <GridOnOutlinedIcon />
                    </Button>
                    <Button
                      action
                      tooltipClassName={classes.longtooltip}
                      align="right"
                      tooltipText="Export Word"
                      justIcon
                      round
                      simple
                      size="sm"
                      color="primary"
                      onClick={() => handleExportWord(prop.Id)}
                    >
                      <DescriptionOutlinedIcon />
                    </Button>
                  </>
                )}
              </div>
            ),
          };
        })
      );
    }
  }, [dataInquiry]);

  const classes = useStyles();

  const columns = [
    {
      Header: "Inquiry",
      accessor: "inquiry",
      alignment: "center",
    },
    {
      Header: "Process (%)",
      accessor: "process",
      alignment: "center",
    },
    {
      Header: "Created Date",
      accessor: "createdDate",
      alignment: "center",
    },
    {
      Header: "Status",
      accessor: "status",
      alignment: "center",
    },

    {
      Header: (
        <div
          style={{
            textAlign: "center",
          }}
        >
          Actions
        </div>
      ),
      accessor: "actions",
      alignment: "center",
    },
  ];
  // ERROR HANDLING
  if (error) {
    apiErrorHandler(error, history);
  }

  if (loading) {
    return <Loading loading />;
  }

  return (
    <GridContainer className={classes.center}>
      <GridItem xs={12}>
        <Card>
          <CardHeader>
            <TableHeader title="Monitor Activity" />
          </CardHeader>
          <CardBody>
            <ReactTable
              columns={columns}
              data={data}
              loading={loading}
              currentPage={dataInquiry && dataInquiry.currentPage}
              defaultPageSize={dataInquiry && dataInquiry.pageSize}
              totalItems={dataInquiry && dataInquiry.totalItem}
              totalPages={dataInquiry && dataInquiry.totalPage}
              setCurrentPage={setCurrentPage}
            />
          </CardBody>
          {isModalOpen ? (
            <FileUploadModal
              setModalOpen={setModalOpen}
              isModalOpen={isModalOpen}
              inquiryId={inquiryId}
              data={dataInquiry && dataInquiry.data}
              executeGetAllInquiries={ExecuteGetAllInquirySuperAdmin}
            />
          ) : null}
          {isMultiModalOpen ? (
            <MultiFileUploadModal
              setMultiModalOpen={setMultiModalOpen}
              isMultiModalOpen={isMultiModalOpen}
              inquiryId={inquiryId}
              data={dataInquiry && dataInquiry.data}
              executeGetAllInquiries={ExecuteGetAllInquirySuperAdmin}
            />
          ) : null}
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default MonitorActivity;
